/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */

import React, { useMemo } from "react";
import Container from "@/src/components/Container/Container";
import LayoutPublicRoutes from "@/src/containers/Layouts/LayoutPublicRoutes";
import PartnerLogoSection from "@/src/components/Sections/Generic/PartnerLogoSection/PartnerLogoSection";
import LandingPageTeaser from "@/src/components/Teaser/LandingPageTeaser";
import AttorneySection from "@/src/components/Sections/Generic/AttorneySection/AttorneySection";
import DeathCheckin from "@/src/components/Checkin/FamilyLawCheckin/Death/DeathCheckin";
import LpDeathAragMeta from "./Arag/LpDeathAragMeta";
import LpDeathAdvoCardMeta from "./AdvoCard/LpDeathAdvoCardMeta";
import LinkedCardBox from "@/src/components/LinkedCardBox/LinkedCardBox";
import { documentTeaserCards } from "@/src/services/landingPageService";
import { useCustomer } from "@/src/provider/Customer/CustomerProvider";
import { AbstractCase } from "@/src/types/Entities/AbstractCase";
import HowItWorksSectionDeath from "@/src/components/Sections/FamilyLaw/Death/HowItWorksSection/HowItWorksSectionDeath";
import { PARTNER_IRIS } from "@/src/constants/partnerIris";

const getMetaDataByPartner = ({ partner }: { partner: string }) => {
  switch (partner) {
    case PARTNER_IRIS.ADVOCARD:
      return <LpDeathAdvoCardMeta />;
    case PARTNER_IRIS.ARAG:
      return <LpDeathAragMeta />;
    default:
      return null;
  }
};

const LpDeathPartner = ({ partner }: { partner: NonNullable<AbstractCase["acquisitionPartner"]> }) => {
  const { isLoggedIn } = useCustomer();
  const metaData = useMemo(() => getMetaDataByPartner({ partner }), [partner]);

  return (
    <LayoutPublicRoutes minimal={!isLoggedIn} clickableLogo={isLoggedIn}>
      {metaData}
      <LandingPageTeaser
        headline={"Professionelle Hilfe bei Todesfall & Erbe"}
        subheadline={"Informationen erhalten und Gespräch vereinbaren"}
        teaserButtonLink={isLoggedIn ? "/servicewelt" : "#top-checkin"}
      >
        <LinkedCardBox linkedCards={documentTeaserCards} />
      </LandingPageTeaser>
      <PartnerLogoSection partnerIri={partner} containerStyle={"settlementContainer"} />
      {!isLoggedIn && (
        <Container>
          <DeathCheckin idPrefix={"top"} partner={partner} />
        </Container>
      )}
      <HowItWorksSectionDeath />
      <AttorneySection
        subheading={"Sie möchten sich professionell und schnell unterstützen lassen? Wir helfen Ihnen - jederzeit und ortsunabhängig!"}
        heading={"Deutschlandweit tätige Partneranwälte"}
      />
      {!isLoggedIn && (
        <Container>
          <DeathCheckin idPrefix={"top"} partner={partner} />
        </Container>
      )}
    </LayoutPublicRoutes>
  );
};

export default LpDeathPartner;
